import React, {useEffect} from "react";
import Styles from './styles.module.scss'

import Seo from "../../components/_UI/seo";
import {useTranslation} from "react-i18next";
import AuthRedirect from "../../components/authRedirect";
import CabinetProfileAvatar from "../../components/cabinet/cabinetProfileAvatar";
import CabinetProfilePersonalInformation from "../../components/cabinet/cabinetProfilePersonalInformation";
import CabinetProfilePersonalInformationEditModal
    from "../../components/cabinet/cabinetProfilePersonalInformationEditModal";
import CabinetProfileSecurity from "../../components/cabinet/cabinetProfileSecurity";
import CabinetProfilePaymentMetods from "../../components/cabinet/cabinetProfilePaymentMetods";
import {useDispatch} from "react-redux";
import {getProfileMainData} from "../../store/cabinet/action";
import CabinetProfileChangePasswordModal from "../../components/cabinet/cabinetProfileChangePasswordModal";
import CabinetProfileTwoFactorModal from "../../components/cabinet/cabinetProfileTwoFactorModal";
import CabinetProfileDisableTwoFactorModal from "../../components/cabinet/cabinetProfileDisableTwoFactorModal";



const CabinetProfilePage = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getProfileMainData());
    }, [dispatch]);

    return (
        <section className={`${Styles.container} ${Styles.cabinetPC}`}>
            <Seo title={t('Профиль')}/>
            <AuthRedirect isCabinet={true}/>
            <div className={`${Styles.cabinetNote}`}>{t('Профиль')}</div>
            <div className={`${Styles.posWrap}`}>
                <CabinetProfileAvatar/>
                <CabinetProfilePersonalInformation/>
                <CabinetProfileSecurity/>
                <CabinetProfilePaymentMetods/>
            </div>
            <CabinetProfilePersonalInformationEditModal/>
            <CabinetProfileChangePasswordModal/>
            <CabinetProfileTwoFactorModal/>
            <CabinetProfileDisableTwoFactorModal/>
        </section>
    );
};

export default CabinetProfilePage;